import React from "react";
export var useScrollRef = function () {
  var ref = React.useRef();
  return {
    ref: ref,
    scrollTo: function (_a) {
      var x = _a.x,
        y = _a.y,
        _b = _a.behavior,
        behavior = _b === void 0 ? 'auto' : _b;
      if (ref && ref.current) {
        if (x) {
          ref.current.scrollLeft = x;
        }
        if (y) {
          ref.current.scrollTop = y;
        }
      }
    }
  };
};